import { createRouteRef } from '@backstage/core-plugin-api';

export const entityContentRouteRef = createRouteRef({
  id: 'snyk-branch-view',
});

export const snykOverviewRouteRef = createRouteRef({
  id: 'snyk-overview',
});
